<template>
  <div>
    <div class="pt-16 md:pt-20 px-6 text-gray-200 pb-4 md:pb-16" style="background-image: url('https://res.cloudinary.com/showman/image/upload/c_scale,h_350,f_auto/v1633036018/Showman_backdrop_1.png');">
      <div class="max-w-5xl mx-auto">
        <div class="flex flex-col md:flex-row justify-start md:justify-center items-start md:items-center pb-6 md:pb-8">
          <h1 class="text-white md:text-center text-5xl lg:text-6xl font-bold leading-none sm:leading-tighter">
            <span class="inline-flex relative text-white">
              <span aria-hidden="" class="absolute inset-0 bg-showman" style="transform: skewY(-1.3deg) scaleX(1.05) scaleY(1.05);"></span>
              <span class="relative">The easiest</span>
            </span>
            way to run <br class="hidden md:block">your livestock show.</h1>
          <!--<h1 class="text-white md:text-center text-5xl lg:text-6xl font-bold leading-none sm:leading-tighter">
            <span class="inline-flex relative text-white">
              <span aria-hidden="" class="absolute inset-0 bg-showman" style="transform: skewY(-1.3deg) scaleX(1.05) scaleY(1.05);"></span>
              <span class="relative">The best</span>
            </span>
            livestock show management software in the industry.</h1>-->
        </div>

        <div class="max-w-2xl mx-auto text-xl sm:text-2xl text-gray-200 md:text-center leading-snug sm:tracking-snug pb-10">
          <h2 class="font-light">
              Join the 2000+ shows at the forefront of the livestock industry. Showman is livestock show management software that helps you get on with the show! We do more so you can stress less.
            </h2>
          <!--<p class="font-light">
            Showman gives you the tools that make it easier than ever to run your livestock show. From the first online entry to recording the final results, Showman helps you get on with the show!
          </p>-->
        </div>

      <div class= "flex flex-col justify-center md:flex-row md:items-center mb-20 text-center">
        <a onclick="fathom.trackGoal('PPBJ1VUV', 0);" href="/shows/#/new-show-signup" class="py-4 px-8 border-2 border-showman bg-showman rounded-full m-2 text-2xl font-medium hover:bg-orange-500 hover:border-orange-400">Create My Show</a>
        <button onclick="fathom.trackGoal('WWVUZSXN', 0);" type="button" class="inline-flex justify-center py-4 px-8  rounded-full m-2 text-xl font-medium hover:underline" @click="demoOpen=true">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Watch the Demo
        </button>
      </div>
          <!--<p class="font-semibold text-white leading-snug sm:tracking-snug text-lg sm:text-xl md:text-center">Running your livestock show will never be the same!</p>-->
      </div>
    </div>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div v-if="demoOpen" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="flex items-center sm:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!--
          Background overlay, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="inline-block align-bottom bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl w-full">
          <div style="padding:61.22% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/732759892?h=1791613136&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Showman | Admin Overview"></iframe></div>
          <div class="flex justify-center">
            <button class="btn btn-gray my-1" @click="demoOpen=false">Close Video</button>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="w-full text-gray-200 bg-showman ">
      <div class="relative z-10 container mx-auto sm:flex sm:items-center justify-center px-6 md:px-12">
        <iframe class="md:-my-8 rounded-lg" src="https://player.vimeo.com/video/605171753?h=b9be0c1b9a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="300" height="184" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        <div class="ml-6 md:ml-10 text-center sm:text-left py-6">
            <p class="text-white text-xl lg:text-2xl font-bold leading-none sm:leading-tighter sm:text-center">Need More Info?</p>
            <p class="text-lg">Check out this short demo or keep scrolling to learn more.</p>
        </div>
      </div>
    </div>-->
    <div class="w-full bg-orange-500 p-6">
      <div class="text-center text-gray-200">
        <h3 class="text-xl md:text-3xl font-bold text-white">Are you an exhibitor looking to enter a show?</h3>
      </div>
      <div class="max-w-6_xl mx-auto px-2">
        <div class="p-3 rounded w-full">
          <div class="whitespace-no-wrap overflow-scroll flex">
            <event-card v-for="s in upcomingShows" :key="s.name" :event="s" class="m-2 flex-none w-full md:w-56" :type="'small'" :forceFullLoad="true"></event-card>
          </div>
        </div>
        <div class="flex justify-center text-center items-center flex-wrap">
          <a class="btn text-gray-800 bg-white border rounded shadow-sm border-gray-300 hover:bg-gray-100 ml-4" href="/shows">Click here to view all shows</a>
        </div>
      </div>
    </div>
    <div id="testimonials">
      <div class="sm:flex w-full divide-y sm:divide-y-0 sm:divide-x divide-dashed divide-gray-400 my-12 text-center">
        <div class="sm:w-1/2 md:w-1/3">
          <div class="px-6 py-12 text-lg lg:text-xl leading-6 lg:leading-7">
            <img src="https://res.cloudinary.com/showman/image/upload/w_80/v1655138321/Testimonial_The_Classic.png" width="400" height="400" class="block w-20 h-20 rounded-lg mx-auto" alt="Chris" loading="lazy">
            <!--<p class="text-base font-medium flex-grow py-6 text-gray-200 lg:tracking-tight">“I cannot express to you enough how well Showman worked for our show. Your customer service was absolutely amazing and the way you were able to customize your program to fit our show was spectacular. We had a very smooth ran show and grossed more than ever before!”</p>-->
            <p class="text-base font-medium flex-grow py-6 text-gray-200 lg:tracking-tight">“I cannot express to you enough how well Showman worked for our show. Your customer service was absolutely amazing and the way you were able to customize your program to fit our show was spectacular.”</p>

            <div class="text-lg text-white font-medium">The Classic/AGR Spring Showdown</div>
            <div class="text-base text-gray-300">Iowa State University Block & Bridle and AGR</div>
          </div>
        </div>

        <div class="sm:w-1/2 md:w-1/3">
          <div class="px-6 py-12 text-lg lg:text-xl leading-6 lg:leading-7">
            <img src="https://res.cloudinary.com/showman/image/upload/w_80/v1655138704/Testimonial_Boatman.png" width="400" height="400" class="block w-20 h-20 rounded-lg mx-auto" alt="Tracy" loading="lazy">
            <p class="text-base font-medium flex-grow py-6 text-gray-200 lg:tracking-tight">“Just wanted to say thank you. The Show went off without a hitch. We'll be back next year! The app saved me a ton of time and stress! ”</p>
            <div class="text-lg text-white font-medium">Wendi Boatman</div>
            <div class="text-base text-gray-300">Boatman Club Lambs</div>
          </div>
        </div>

        <div class="sm:w-1/2 md:w-1/3">
          <div class="px-6 py-12 text-lg lg:text-xl leading-6 lg:leading-7">
            <img src="https://res.cloudinary.com/showman/image/upload/w_80/v1659814959/Testimonal_The_Golden.png" width="400" height="400" class="block w-20 h-20 rounded-lg mx-auto" alt="Chris" loading="lazy">
            <!--<p class="text-base font-medium flex-grow py-6 text-gray-200 lg:tracking-tight">“Using the Showman app has improved the efficiency of our livestock shows immensely. From gathering early entries to running a smooth show the day of, this has made a big difference in how organized we are. Our exhibitor families also like that they can enter, modify and pay online as well. This is exactly the type of program I was looking for several years ago and I can’t recommend it enough!”</p>-->
            <p class="text-base font-medium flex-grow py-6 text-gray-200 lg:tracking-tight">“Using the Showman app has improved the efficiency of our livestock shows immensely. From gathering early entries to running a smooth show the day of, this has made a big difference in how organized we are... I can’t recommend it enough!”</p>
            <div class="text-lg text-white font-medium">Alena Standley</div>
            <div class="text-base text-gray-300">Montana Farm Bureau Federation, The Golden</div>
          </div>
        </div>
      </div>
    </div>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="py-12 sm:py-20 bg-white">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <h1 class="sm:text-5xl text-4xl font-sans font-bold text-showman leading-7 text-ce_nter">Ditch the showday headaches</h1>
        <p class="sm:text-3xl text-2xl font-sans text-gray-900 mt-4">Do any of these scenarios sound familiar?</p>

        <dl class="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-8">
          <div>
            <dt>
              <p class="mt-5 text-xl leading-6 font-medium text-gray-900">All night data entry</p>
            </dt>
            <dd class="mt-2 text-base text-gray-700">
              It's 9PM on a Thursday night. You sit down at your desk to begin the grueling task of processing the paper show entries you received in the mail. You take a deep breath, fire up excel and get to work. Half way through the stack you throw your hands in the air, look up towards the heavens and scream "There has to be another way!"
            </dd>
          </div>

          <div>
            <dt>
              <p class="mt-5 text-xl leading-6 font-medium text-gray-900">Long lines at check-in or weigh-in</p>
            </dt>
            <dd class="mt-2 text-base text-gray-700">
              It's the day of the show! Everything is set up and the exhibitors start to arrive - you are ready for a great day! The scales open and immediately the line starts building up. The process is slow as you try to collect exhibitor info and payments as they come across the scales. It's loud and hard to understand people, with animals all around, kids screaming and an edge of competition in the air. Talk about a stressful situation!
            </dd>
          </div>

          <!--<div>
            <dt>
              <p class="mt-5 text-xl leading-6 font-medium text-gray-900">Frantically breaking classes</p>
            </dt>
            <dd class="mt-2 text-base text-gray-700">
              Check-in is finally closed, you sit down to start breaking clases. The show is scheduled to start in 1 hour, the pressure is on. As show time draws closer you are barraged with constant questions about the class lists, about when the show will start, and which class am I in? Why does breaking classes have to be so time consuming? Isn't there an easy to use interface for breaking classes? Is starting a show on time even possible?
            </dd>
          </div>-->
        </dl>
        <!--<div class="max-w-6xl mx-auto mt-10 lg:mt-20 lg:flex lg:items-center">
          <div class="lg:w-1/2 lg:mr-2">
            <p class="text-3xl font-extrabold text-showman mb-4">
              Showman is here to help.
            </p>
            <p class="text-lg leading-5 text-gray-800">
              Maybe the above narratives are a bit melodramatic, you may even enjoy some or all aspects of the scenarios described.
              The bottom line is this, putting on a show is a lot of work and Showman is here to help make your life easier.
            </p>
          </div>
          <div class="lg:w-1/2 mt-10 lg:-mx-4 lg:pl-16 relative lg:mt-0" aria-hidden="true">
            <img class="relative mx-auto rounded-lg shadow-lg px-4 md:px-0" width="490" src="https://res.cloudinary.com/showman/image/upload/c_scale,w_490,f_auto/v1633045641/ShowHomepage_Screenshot.png" alt="">
          </div>
        </div>-->
      </div>
    </div>

    <!--<div class="py-16 bg-white overflow-hidden lg:py-24">
      <div class="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-6xl">

        <div class="relative">
          <h2 class="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Built for livestock shows
          </h2>
          <p class="mt-4 max-w-3xl mx-auto text-center text-xl text-gray-700">
            Showman was custom built for your livestock show. Helping you save time, keep organized and stay sane.
          </p>
        </div>

        <div class="mt-12">
          <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div class="pt-6">
              <div class="flow-root bg-gray-100 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div class="flex justify-center">
                    <span class="inline-flex items-center justify-center p-3 bg-showman rounded-md shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                      </svg>
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">Dedicated Show Homepage</h3>
                  <p class="mt-5 text-base text-gray-700">
                    The go to place for exhibitors, sponsors and spectators to find all the information about your show.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-6">
              <div class="flow-root bg-gray-100 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div class="flex justify-center">
                    <span class="inline-flex items-center justify-center p-3 bg-showman rounded-md shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">Online Entries</h3>
                  <p class="mt-5 text-base text-gray-700">
                    Accept online entries, saving you the time of manual entry and giving exhibitors more visibility of their data.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-6">
              <div class="flow-root bg-gray-100 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div class="flex justify-center">
                    <span class="inline-flex items-center justify-center p-3 bg-showman rounded-md shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">Online Payments</h3>
                  <p class="mt-5 text-base text-gray-700">
                    Stop dealing with cash and checks, online payments save you time and hassle.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-6">
              <div class="flow-root bg-gray-100 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div class="flex justify-center">
                    <span class="inline-flex items-center justify-center p-3 bg-showman rounded-md shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">Access your data anywhere</h3>
                  <p class="mt-5 text-base text-gray-700">
                    Pull up your latest show's data at home or on the go in your show admin dashboard.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-6">
              <div class="flow-root bg-gray-100 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div class="flex justify-center">
                    <span class="inline-flex items-center justify-center p-3 bg-showman rounded-md shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                      </svg>
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">Showday Tools</h3>
                  <p class="mt-5 text-base text-gray-700">
                    Showday will be a breeze with the built in tools to help with check-in, show books, printouts and results.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-6">
              <div class="flow-root bg-gray-100 rounded-lg px-6 pb-8">
                <div class="-mt-6">
                  <div class="flex justify-center">
                    <span class="inline-flex items-center justify-center p-3 bg-showman rounded-md shadow-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </span>
                  </div>
                  <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">Happy Exhibitors</h3>
                  <p class="mt-5 text-base text-gray-700">
                    Exhibitors love using Showman. Keep your exhibitors happy and better informed at your show.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <div class="relative overflow-hidden bg-white pt-8 pb-32">
      <div class="mx-auto max-w-screen-xl px-6 pt-8 sm:pt-16 md:pt-28">
        <h2 class="bg-orange-100 px-2 border-b-2 border-t-2 border-orange-400 py-3 text-5xl sm:text-5xl md:text-6xl lg:text-6xl font-headline font-black text-gray-900 tracking-snug leading-tight sm:leading-tight md:leading-tight lg:leading-tight md:text-center">
          More than an online form
        </h2>
        <!--<h2 class="bg-orange-100 px-2 border-b-2 border-t-2 border-orange-400 py-3 text-2xl sm:text-2xl md:text-3xl lg:text-4xl font-headline font-black text-gray-900 tracking-snug leading-tight sm:leading-tight md:leading-tight lg:leading-tight md:text-center">
          <div class="flex justify-center space-x-2">
            <span class="line-through">Paper & Pencil, </span>
            <span class="line-through">Spreadsheets, </span>
            <span class="line-through">Online Forms</span>
          </div>
          <span class="text-5xl lg:text-6xl">More than an online form</span>
        </h2>-->
      </div>
      <div class="max-w-screen-xl mx-auto">
        <div class="relative mt-20 sm:mt-32">
          <div class="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8">
            <div class="mx-auto max-w-xl px-6 lg:mx-0 lg:max-w-none lg:py-16 lg:px-0">
              <div>
                <div class="mt-6">
                  <h2 class="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">All the tools you need to run your livestock show</h2>
                  <dl class="mt-10 max-w-xl space-y-2 text-base leading-7 text-gray-600 lg:max-w-none">
                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Sit back and watch the entries roll in.
                      </dt>
                      <dd class="inline">Skip the late nights of manual data entry and the stress of tracking payments.</dd>
                    </div>

                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Get sponsors while you sleep.
                      </dt>
                      <dd class="inline"> Set up an online sponsor form and let the sponsors come to you.</dd>
                    </div>

                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Make show day a breeze!
                      </dt>
                      <dd class="inline">Ditch the long lines and rushing to get classes posted. Showman's built in tools will have you smiling on show day.</dd>
                    </div>
                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Results...done!
                      </dt>
                      <dd class="inline">Record your results right from ringside and have them published before you get home.</dd>
                    </div>
                  </dl>
                </div>
              </div>
              <div class="mt-8 border-t border-gray-200 pt-6">
                <blockquote>
                  <div>
                    <p class="text-base text-gray-600">&ldquo;Using Showman has eliminated hours of collecting entries and payments, putting together classes and clerk sheets and recording placings. Having them handle payments and sending us our money simplifies the whole accounting process.&rdquo;</p>
                  </div>
                  <div class="mt-3">
                    <div class="flex items-center space-x-3">
                      <div class="flex-shrink-0">
                        <img class="h-12 w-12 rounded-full" src="https://res.cloudinary.com/showman/image/upload/w_80/v1659808091/TESTIMONAL_SMALL_WESTERN_HOG.png" alt="">
                      </div>
                      <div class="text-base font-medium text-gray-800">Wynn Mayfield, Western Hog Services/Oregon Spring Classic</div>
                    </div>
                  </div>
                </blockquote>
              </div>
            </div>
            <div class="mt-12 sm:mt-16 lg:mt-0">
              <div class="-mr-48 pl-6 md:-mr-16 lg:relative lg:m-0 lg:h-full lg:px-0">
                <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="https://res.cloudinary.com/showman/image/upload/w_1100/v1676083004/Screen_Shot_2023-02-10_at_9.36.37_PM.png" alt="Inbox user interface">
              </div>
            </div>
          </div>
        </div>
        <div class="mt-24">
          <div class="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8">
            <div class="mx-auto max-w-xl px-6 lg:col-start-2 lg:mx-0 lg:max-w-none lg:py-16 lg:px-0">
              <div>
                <div class="mt-6">
                  <h2 class="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900">An online entry platform exhibitors love</h2>
                  <dl class="mt-10 max-w-xl space-y-2 text-base leading-7 text-gray-600 lg:max-w-none">
                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Easy to use tools.
                      </dt>
                      <dd class="inline">Exhibitors love how convenient it is for them to submit their entry and payment information online.</dd>
                    </div>

                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Save animal info.
                      </dt>
                      <dd class="inline">Showman has true accounts that save exhibitors' progress and animal information. </dd>
                    </div>
                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Skip the long lines.
                      </dt>
                      <dd class="inline">With the ability to edit and add entry info up until check-in, exhibitors spend less time in line and more time getting ready for the show.</dd>
                    </div>
                    <div class="relative pl-8">
                      <dt class="inline font-semibold text-gray-900">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute top-1 left-0 h-6 w-6 text-orange-500">
                          <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                        </svg>
                        Classes in the palm of your hand.
                      </dt>
                      <dd class="inline">Publish your show books and results to let exhibitors and spectators follow along from their phone while sitting ringside.</dd>
                    </div>
                  </dl>
                </div>
              </div>
              <div class="mt-8 border-t border-gray-200 pt-6">
                <blockquote>
                  <div>
                    <p class="text-base text-gray-600">&ldquo;Using Showman was a HUGE success. I had many compliments about the easy entry process and everyone who used it on the admin side found it to be very useful. We will definitely be using showman.app in the future.&rdquo;</p>
                  </div>
                  <div class="mt-3">
                    <div class="flex items-center space-x-3">
                      <div class="flex-shrink-0">
                        <img class="h-12 w-12 rounded-full" src="https://res.cloudinary.com/showman/image/upload/w_80/v1659814632/Testimonal_Fletcher_Larson.png" alt="">
                      </div>
                      <div class="text-base font-medium text-gray-800">Fletcher Larson, Nebraska State Hereford Show</div>
                    </div>
                  </div>
                </blockquote>
              </div>
            </div>
            <div class="mt-12 sm:mt-16 lg:col-start-1 lg:mt-0">
              <div class="-ml-48 pr-6 md:-ml-16 lg:relative lg:m-0 lg:h-full lg:px-0">
                <img class="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none" src="https://res.cloudinary.com/showman/image/upload/w_1100/v1676081591/Screen_Shot_2023-02-10_at_9.13.04_PM.png" alt="Customer profile user interface">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-900">
      <div class="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <h2 class="text-3xl font-extrabold tracking-tight text-gray-100 sm:text-4xl">
          <span class="block">Ready to get started?</span>
          <span class="block">Get your show set up today.</span>
        </h2>
        <div class="mt-8 flex justify-center">
          <div class="inline-flex rounded-lg shadow">
            <a onclick="fathom.trackGoal('PPBJ1VUV', 0);" href="/shows/#/new-show-signup" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-bold rounded-lg text-orange-100 bg-showman hover:bg-orange-500">
              Start my set up
            </a>
          </div>
          <div class="ml-3 inline-flex">
            <a href="mailto:support@showman.app" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-lg text-gray-900 bg-white hover:bg-gray-200">
              Ask a question
            </a>
          </div>
        </div>
        <p onclick="fathom.trackGoal('HIJDFCOU', 0);" class="text-gray-100 mt-8">Want to talk to someone? <router-link class="link font-bold" to="/request-a-demo">Schedule a demo</router-link></p>
      </div>
    </div>

    <div class="bg-white pt-12 md:pt-16">
      <div class="max-w-6xl mx-auto px-8">
        <div class="flex flex-col lg:flex-row justify-between items-center">
          <div>
            <h3 class="font-sans pb-6 text-3xl font-bold">
              The Showman Journey
            </h3>
            <p class="main-copy">
              Showman launched for early access in April of 2019 and public access in January 2020. Since then over 2000 shows have used Showman in 44 states across the United States.
            </p>
            <div class="main-copy font-semibold">
              <p><a class="link" href="/#/about">Learn more about the story of Showman</a></p>
              <!--<p><a class="link" href="/#/ask-a-question">View our FAQ's or ask a question</a></p>-->
            </div>
          </div>
          <img class="sm:w-full sm:max-w-md md:max-w-lg mx-auto rounded-lg" src="https://res.cloudinary.com/showman/image/upload/c_fill,g_auto,w_500,q_auto,f_auto/v1681080673/4-23_StateMap.png">
        </div>
      </div>
    </div>
    <div class="bg-gray-900">
      <div class="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8 lg:py-12">
        <div class="max-w-4xl mx-auto text-center">
          <h2 class="text-3xl font-extrabold text-gray-100 sm:text-4xl">
            Trusted by shows all across the United States
          </h2>
          <!--<p class="mt-3 text-xl text-gray-600 sm:mt-4">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repellendus repellat laudantium.
          </p>-->
        </div>
        <dl class="mt-10 text-center sm:max-w-3xl sm:mx-auto sm:flex sm:justify-between sm:gap-8">
          <div class="flex flex-col">
            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-100">
              Shows
            </dt>
            <dd class="order-1 text-5xl font-extrabold text-showman">
              2000+
            </dd>
          </div>
          <div class="flex flex-col mt-10 sm:mt-0">
            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-100">
              Exhibitors
            </dt>
            <dd class="order-1 text-5xl font-extrabold text-showman">
              145K+
            </dd>
          </div>
          <div class="flex flex-col mt-10 sm:mt-0">
            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-gray-100">
              Entries
            </dt>
            <dd class="order-1 text-5xl font-extrabold text-showman">
              985K+
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import EventCard from '@/components/EventCard.vue'

export default {
  components: {
    EventCard
  },
  name: 'landing',
  data () {
    return {
      demoOpen: false,
      email: '',
      name: '',
      formStatus: 'none',
      missingField: '',
      loadingData: true,
      events: [],
      contest_only: null,
      errorMessage: '',
      upcomingShows: [],
      supportEmail: process.env.VUE_APP_SUPPORT_EMAIL,
      show_giveaway: true
    }
  },
  created () {
    this.loadShowData()
  },
  methods: {
    loadShowData () {
      this.axios(`${process.env.VUE_APP_ROOT_API}/callFunction/showman`)
        .then(response => {
          this.upcomingShows = response.data.data.upcoming.slice(0, 15)
        })
    },
    /* subscribeClicked (event) {
      if (!this.email) {
        this.missingField = 'email'
        return
      } else if (!this.name) {
        this.missingField = 'name'
        return
      }
      this.missingField = ''
      this.formStatus = 'loading'
      this.axios.post(`${process.env.VUE_APP_ROOT_API}/showman/add-subscriber?email=${this.email}&first=${this.name}`)
        .then(() => {
          // console.log('in then')
          this.formStatus = 'success'
        })
        .catch(error => {
          // console.log('in error')
          // console.log(error)
          this.formStatus = 'error'
          if (error.response.data.error.title === 'Member Exists') {
            this.errorMessage = `It looks like you have already signed up using this email. If you would like to update your information or have any questions you can send an email to ${process.env.VUE_APP_SUPPORT_EMAIL}`
          } else {
            this.errorMessage = `Well this is embarrasing, I'm not sure what is wrong. You can refresh your browser and try again. If that doesn't work please send an email to ${process.env.VUE_APP_SUPPORT_EMAIL} for help.`
          }
          // this.$honeybadger.notify(error)
        })
    },
    enteredClicked (event) {
      if (!this.name) {
        this.missingField = 'name'
        return
      } else if (!this.email) {
        this.missingField = 'email'
        return
      }
      this.missingField = ''
      this.formStatus = 'loading'

      this.axios.post(`${process.env.VUE_APP_ROOT_API}/showman/add-subscriber-giveaway?email=${this.email}&first=${this.name}&contest_only=${this.contest_only}`)
        .then(() => {
          this.formStatus = 'success'
        })
        .catch(error => {
          this.formStatus = 'error'
          if (error.response.data.error.title === 'Member Exists') {
            this.errorMessage = `It looks like you have already signed up using this email. If you would like to update your information or have any questions you can send an email to ${process.env.VUE_APP_SUPPORT_EMAIL}`
          } else {
            this.errorMessage = `Well this is embarrasing, I'm not sure what is wrong. You can refresh your browser and try again. If that doesn't work please send an email to ${process.env.VUE_APP_SUPPORT_EMAIL} for help.`
          }
          // this.$honeybadger.notify(error)
        })
    }, */
    playDemoVideo () {

    }
  }
}
</script>

<style>

.show-list {
  background-color: #525252;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 304 304' width='304' height='304'%3E%3Cpath fill='%233a3a3a' fill-opacity='0.23' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-10.1zm-64 96a5 5 0 1 1 0-2H208v-80h16v-14h-42.1a5 5 0 1 1 0-2H226v18h-16v80h-12.1zm86.2-210a5 5 0 1 1 0 2H272V0h2v32h10.1zM98 101.9V146H53.9a5 5 0 1 1 0-2H96v-42.1a5 5 0 1 1 2 0zM53.9 34a5 5 0 1 1 0-2H80V0h2v34H53.9zm60.1 3.9V66H82v64H69.9a5 5 0 1 1 0-2H80V64h32V37.9a5 5 0 1 1 2 0zM101.9 82a5 5 0 1 1 0-2H128V37.9a5 5 0 1 1 2 0V82h-28.1zm16-64a5 5 0 1 1 0-2H146v44.1a5 5 0 1 1-2 0V18h-26.1zm102.2 270a5 5 0 1 1 0 2H98v14h-2v-16h124.1zM242 149.9V160h16v34h-16v62h48v48h-2v-46h-48v-66h16v-30h-16v-12.1a5 5 0 1 1 2 0zM53.9 18a5 5 0 1 1 0-2H64V2H48V0h18v18H53.9zm112 32a5 5 0 1 1 0-2H192V0h50v2h-48v48h-28.1zm-48-48a5 5 0 0 1-9.8-2h2.07a3 3 0 1 0 5.66 0H178v34h-18V21.9a5 5 0 1 1 2 0V32h14V2h-58.1zm0 96a5 5 0 1 1 0-2H137l32-32h39V21.9a5 5 0 1 1 2 0V66h-40.17l-32 32H117.9zm28.1 90.1a5 5 0 1 1-2 0v-76.51L175.59 80H224V21.9a5 5 0 1 1 2 0V82h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H300.1a5 5 0 0 1 3.9-3.9v2.07a3 3 0 0 0 0 5.66v2.07a5 5 0 0 1-3.9-3.9H185.41L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 18a5 5 0 1 1 0-2h18.69l7.41-7.41v2.82L297.41 50H277.9zm-16 160a5 5 0 1 1 0-2H288v-71.41l16-16v2.82l-14 14V210h-28.1zm-208 32a5 5 0 1 1 0-2H64v-22.59L40.59 194H21.9a5 5 0 1 1 0-2H41.41L66 216.59V242H53.9zm150.2 14a5 5 0 1 1 0 2H96v-56.6L56.6 162H37.9a5 5 0 1 1 0-2h19.5L98 200.6V256h106.1zm-150.2 2a5 5 0 1 1 0-2H80v-46.59L48.59 178H21.9a5 5 0 1 1 0-2H49.41L82 208.59V258H53.9zM34 39.8v1.61L9.41 66H0v-2h8.59L32 40.59V0h2v39.8zM2 300.1a5 5 0 0 1 3.9 3.9H3.83A3 3 0 0 0 0 302.17V256h18v48h-2v-46H2v42.1zM34 241v63h-2v-62H0v-2h34v1zM17 18H0v-2h16V0h2v18h-1zm273-2h14v2h-16V0h2v16zm-32 273v15h-2v-14h-14v14h-2v-16h18v1zM0 92.1A5.02 5.02 0 0 1 6 97a5 5 0 0 1-6 4.9v-2.07a3 3 0 1 0 0-5.66V92.1zM80 272h2v32h-2v-32zm37.9 32h-2.07a3 3 0 0 0-5.66 0h-2.07a5 5 0 0 1 9.8 0zM5.9 0A5.02 5.02 0 0 1 0 5.9V3.83A3 3 0 0 0 3.83 0H5.9zm294.2 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E");
}

.primary {
  fill: hsl(0, 0%, 80%);
}
.secondary {
  fill: hsl(0, 0%, 70%);
}
.advantage .primary {
  fill: #F6AD55;
}
.advantage .secondary {
  fill: #000;
}
</style>
